import { useEffect, useState } from "react";
import { getImageFromDB } from "../utils/indexedDB";

const useLoadDBImage = (storeName, imageId, productId = null, resultImageId = null) => {
  const [imageUrl, setImageUrl] = useState(null);
  

  useEffect(() => {

    if (!imageId && !productId && !resultImageId) return;

    const fetchImage = async () => {
      let imageBlob;

      if (storeName === "onProductImages") {
        imageBlob = await getImageFromDB(storeName, null, { productId, resultImageId });
      } else {
        imageBlob = await getImageFromDB(storeName, imageId);
      }

      if (imageBlob) {
        setImageUrl(URL.createObjectURL(imageBlob));
      }
    };

    fetchImage();
  }, [storeName, imageId, productId, resultImageId]);

  return imageUrl;
};

export default useLoadDBImage;
